import { useReducer } from 'react';
import { Link } from 'react-router-dom';

import { getTestProps } from '../../../lib/helpers';

import { CaretDownSolidIcon } from '../../../images/shapes';

const TopNavPanel = ({ label, items, testId }) => {
  const [open, toggleOpen] = useReducer((open) => !open, false);

  return (
    <div
      className="group/mobile-items pl-6 pr-2"
      data-state={open ? 'open' : 'closed'}
    >
      <button
        className="peer py-3 w-full hover:text-blue text-2xl flex justify-center items-center font-bold"
        onClick={toggleOpen}
        {...getTestProps(testId, `open`)}
      >
        {label}
        <CaretDownSolidIcon
          className="w-5 h-5 inline ml-auto text-blue group-data-[state=open]/mobile-items:rotate-180
                    transition-transform duration-300"
        />
      </button>
      <ul className="hidden group-data-[state=open]/mobile-items:flex flex-col font-normal text-xl">
        {items.map(({ key, label, url }) => (
          <li className="h-full flex hover:bg-gray" key={key}>
            <Link
              className="w-full py-2 pl-2 hover:no-underline hover:text-indigo-950 
                        focus:no-underline focus:text-text-indigo-950"
              to={url}
              {...getTestProps(testId, `link-${key}`)}
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TopNavPanel;
